import styled from 'styled-components';

export const ChartItem = styled.div`
  height: 300px;
  width: 100%;
  display: flex;
`;

export const MetricNumbersTextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 235px;
    box-sizing: border-box;
    margin-top: 30px;
`;

export const MetricContent = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    flex-grow: 1;
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 5px 0px;
`;

export const StyledParaHeader = styled.p`
  font-size: 13px;
`;

export const StyledPara = styled.p`
  font-size: 13px;
  font-weight: 100;
  text-align: left;
`;
